<div [ngStyle]="{'height.px':sizeY+174,'width.px':sizeX,'padding':'-24px'}" [ngClass]="{'hide-dialog': !showDialog}">
    <!--TITLE-->
    <mat-toolbar matDialogTitle class="m-0 mb-24" set-color [backgroundColor]="subjectType.color">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title">{{(isNew===false) ? 'Edit':'Add'}} {{subjectType.name}} {{(subject.isReferral) ? 'Referral':''}}</span>
            <button id="btnCloseSubjectDlg" mat-icon-button class="mat-icon-button"
                    (click)="dialogRef.close()"
                    aria-label="Close dialog"
                    tabindex="-1">
                    <mat-icon set-color [backgroundColor]="subjectType.color">close</mat-icon>
            </button>
        </div>
    </mat-toolbar>

    <div *ngIf="showSubject" [ngStyle]="{'height.px':sizeY}">
        <subject-edit [subject]="subject" (onChanged)="subjectChanged($event)" (onLayoutChanged)="layoutChanged($event)" (onFormValid)="formValid($event)"></subject-edit>
    </div>

    <!--RELATIONSHIP-->
    <div *ngIf="showRelationships" [ngStyle]="{'height.px':sizeY, 'padding':'24px'}">
        <mat-form-field style="width:100%; max-width: 400px;">
            <mat-select placeholder="Relationship" (selectionChange)="relationshipChanged($event)" required>
                <mat-option *ngFor="let item of possibleRelationships" [value]="item.id">
                    {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div *ngIf="hasRelationships && showSubject">
            <button mat-raised-button
                    id="btnNext"
                    [disabled]="!canNext"
                    (click)="next()"
                    class="save-button mat-accent"
                    aria-label="NEXT">
                NEXT
            </button>
        </div>
        <div style="display: flex;">
            <!-- <div *ngIf="hasRelationships && showRelationships" class="pr-8">
                <button mat-raised-button
                        id="btnBack"
                        (click)="back()"
                        class="save-button mat-accent"
                        aria-label="BACK">
                    BACK
                </button>
            </div> -->
            <div *ngIf="(!hasRelationships) || (hasRelationships && showRelationships)">
                <button mat-raised-button
                        id="btnSubjectSave"
                        type="submit"
                        [disabled]="!canSave"
                        (click)="save()"
                        class="save-button mat-accent"
                        aria-label="SAVE">
                    SAVE
                </button>
            </div>
        </div>
    </div>
</div>
